module.exports = __webpack_public_path__ + "img/mediaPlay.c2bc04af.svg";